import { render } from "./scaleview.vue?vue&type=template&id=0c089b4c"
import script from "./scaleview.vue?vue&type=script&lang=js"
export * from "./scaleview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__